var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scan-region",class:{
    'scan-region--medium-probability': _vm.probability > 60 && _vm.probability < 80,
    'scan-region--low-probability': _vm.probability <= 60 && _vm.probability > 40,
    'scan-region--no-probability': _vm.probability <= 40
  },style:({
    'top': (((_vm.top - _vm.margin)*100) + "%"),
    'left': (((_vm.left - _vm.margin)*100) + "%"),
    'width': (((_vm.width + 2*_vm.margin)*100) + "%"),
    'height': (((_vm.height + 2*_vm.margin)*100) + "%")
  })},[_c('span',{staticClass:"scan-region__value"},[_vm._v(_vm._s(this.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }